import { render, staticRenderFns } from "./LandingSection.vue?vue&type=template&id=bed7c034"
import script from "./LandingSection.vue?vue&type=script&lang=js"
export * from "./LandingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports